import React from 'react';
import StaticPage from '../../components/layouts/StaticPage';

function Jobs() {
  return (
    <StaticPage>
      <h1>Hilf mit, die Gesellschaft näher zusammen zu bringen.</h1>
      <p>Im Moment haben wir leider keine freien Stellen.</p>
      <p>Aber:</p>
      <p>
        Wir sind immer auf der Suche nach talentierten Leuten jeden Alters.
        Schick uns deine Bewerbung an:{' '}
        <a href="mailto:team@triff.app">team@triff.app </a>
      </p>
    </StaticPage>
  );
}

export default Jobs;
